import { reactive } from 'vue';

const state = reactive({
  isDirty: false,
  showConfirm: false,
  toNext: null,
  toNextParams: null,
});

export default function useSaveProtect() {
  function cancelConfirm() {
    state.showConfirm = false;
  }

  function goAhead(router) {
    state.showConfirm = false;
    state.isDirty = false;
    router.push({ name: state.toNext, params: state.toNextParams });
  }

  function closeConfirm() {
    state.showConfirm = false;
  }

  return {
    state,
    cancelConfirm,
    goAhead,
    closeConfirm,
  };
}
